import { BaseAccount, IAccount } from "./IAccount";

/**
 * Auth0-specific account implementation
 * Implements IAccount interface with Auth0 user data
 */
export class Auth0Account extends BaseAccount {
    public readonly sub: string;
    public readonly email?: string;
    public readonly email_verified?: boolean;
    public readonly picture?: string;
    public readonly nickname?: string;
    
    constructor(auth0User: any) {
        const userName = auth0User.upn || auth0User.email || auth0User.nickname || '';
        const name = auth0User.given_name && auth0User.family_name? `${auth0User.given_name} ${auth0User.family_name}` : auth0User.name || auth0User.nickname || auth0User.email || '';

        super(userName, name);
        // Store Auth0-specific properties
        this.sub = auth0User.sub || '';
        this.email = auth0User.email;
        this.email_verified = auth0User.email_verified;
        this.picture = auth0User.picture;
        this.nickname = auth0User.nickname;
    }

    /**
     * Create Auth0Account from Auth0 user object
     */
    static fromAuth0User(auth0User: any): Auth0Account {
        return new Auth0Account(auth0User);
    }

    /**
     * Get unique identifier for this Auth0 account
     */
    getUniqueId(): string {
        return this.sub;
    }

    /**
     * Check if the account has a verified email
     */
    isEmailVerified(): boolean {
        return this.email_verified === true;
    }

    /**
     * Get profile picture URL
     */
    getProfilePicture(): string | undefined {
        return this.picture;
    }

    /**
     * Get display name (prioritizes name over email over nickname)
     */
    getDisplayName(): string {
        return this.name || this.email || this.nickname || this.userName || this.sub;
    }
}